export const section = {
    position: 'relative',
    py: { xs: 6, md: 10 },
};

export const sectionHeader = {
    mb: { xs: 3, md: 4 },
};

export const eyebrow = {
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    color: 'var(--ecal-lightblue)',
    mb: 1,
};

export const title = {
    fontSize: { xs: '1.5rem', md: '2.25rem' },
    fontWeight: 600,
    color: 'var(--ecal-white)',
};

export const gradientEcal = {
    background: 'linear-gradient(90deg, #00D7FF 0%, #0078FF 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
};

export const subtitle = {
    color: 'var(--ecal-lightgrey)',
    mt: 1,
    maxWidth: 640,
    fontSize: '0.875rem',
};
